import { Box, Card, CardContent, Link, Typography } from '@mui/material';
import { useState } from 'react';
import { BaseHeaderTitle, BaseImage, BaseScrollbar } from '~/components/common';
import BaseCalendar from '~/components/common/base-calendar/BaseCalendar';
import * as IconComponents from '~/assets/icons';

const iconComponentList: Array<{
  name: string;
  component: React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string }>;
}> = [];

Object.keys(IconComponents).forEach((name) => {
  iconComponentList.push({ name, component: IconComponents[name as keyof typeof IconComponents] });
});

const Component = () => {
  //#region BaseCalendar
  const [events] = useState([]);

  //#endregion BaseCalendar

  //#region BaseDatePicker
  //#endregion BaseDatePicker

  //#region BaseSelect
  //#endregion BaseSelect

  return (
    <Box className='w-full h-full'>
      {/* Icons */}
      <Card className='mb-[30px]'>
        <CardContent>
          <Typography variant='h5'>{'<Icon />'}</Typography>
          <Box className='flex flex-wrap gap-[10px]'>
            {iconComponentList.map((iconComponent) => {
              const Component = iconComponent.component;
              return (
                <Box
                  className='bg-[#DDDDDD] p-[10px] flex flex-col justify-center items-center w-[150px] h-[100px]'
                  key={iconComponent.name}
                >
                  <Component className='w-[50px] h-[50px] mb-[10px]' />
                  <Box className='w-full truncate text-center'>{iconComponent.name}</Box>
                </Box>
              );
            })}
          </Box>
        </CardContent>
      </Card>

      {/* BaseHeaderTitle */}
      <Card className='mb-[30px]'>
        <CardContent>
          <Typography variant='h5'>{'<BaseHeaderTitle />'}</Typography>
          <Box className='mb-[10px]'>Page title</Box>
          <BaseHeaderTitle title='Component List' />
        </CardContent>
      </Card>
      {/* BaseCalendar */}
      <Card className='mb-[30px]'>
        <CardContent>
          <Typography variant='h5'>{'<BaseCalendar />'}</Typography>
          <Box className='mb-[10px]'>
            Read more:
            <Link href='https://jquense.github.io/react-big-calendar/examples/index.html'>
              {' https://jquense.github.io/react-big-calendar/examples/index.html'}
            </Link>
          </Box>
          <BaseCalendar events={events} style={{ height: '300px' }} />
        </CardContent>
      </Card>
      {/* BaseImage */}
      <Card className='mb-[30px]'>
        <CardContent>
          <Typography variant='h5'>{'<BaseImage />'}</Typography>
          <Box className='mb-[10px]'>Img element with default image</Box>
          <BaseImage />
        </CardContent>
      </Card>
      {/* BaseScrollbar */}
      <Card className='mb-[30px]'>
        <CardContent>
          <Typography variant='h5'>{'<BaseScrollbar />'}</Typography>
          <Box className='mb-[10px]'>
            Read more:
            <Link href='https://grsmto.github.io/simplebar'>{' https://grsmto.github.io/simplebar'}</Link>
          </Box>
          <BaseScrollbar maxHeight='50px'>
            <Box className='border'>
              <Box>Scrollbar content</Box>
              <Box>Scrollbar content</Box>
              <Box>Scrollbar content</Box>
              <Box>Scrollbar content</Box>
              <Box>Scrollbar content</Box>
            </Box>
          </BaseScrollbar>
        </CardContent>
      </Card>

      {/* Form */}
      <Card className='mb-[30px]'>
        <CardContent>
          <Typography variant='h5'>{'<Formik />'}</Typography>
          <Box className='mb-[10px]'>
            Read more:
            <Link href='https://formik.org'>{' https://formik.org'}</Link>
          </Box>
        </CardContent>
      </Card>
      {/* Datetime */}
      <Card className='mb-[30px]'>
        <CardContent>
          <Typography variant='h5'>{'Datetime: dayjs'}</Typography>
          <Box className='mb-[10px]'>
            Read more:
            <Link href='https://day.js.org'>{' https://day.js.org'}</Link>
          </Box>
        </CardContent>
      </Card>
      {/* Drag and Drop */}
      <Card className='mb-[30px]'>
        <CardContent>
          <Typography variant='h5'>{'Drag and Drop'}</Typography>
          <Box className='mb-[10px]'>
            Read more:
            <Link href='https://dndkit.com'>{' https://dndkit.com'}</Link>
          </Box>
        </CardContent>
      </Card>

      {/* notify() */}
      <Card className='mb-[30px]'>
        <CardContent>
          <Typography variant='h5'>{'notify("success", "Message")'}</Typography>
          <Box className='mb-[10px]'>
            Show notification. Read more:
            <Link href='https://fkhadra.github.io/react-toastify/introduction'>
              {' https://fkhadra.github.io/react-toastify/introduction'}
            </Link>
          </Box>
        </CardContent>
      </Card>
      {/* Translation */}
      <Card className='mb-[30px]'>
        <CardContent>
          <Typography variant='h5'>{'Translation: I18next'}</Typography>
          <Box className='mb-[10px]'>
            Read more:
            <Link href='https://www.i18next.com'>{' https://www.i18next.com'}</Link>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Component;
